"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.PathObject = void 0;
var clone_deep_1 = __importDefault(require("clone-deep"));
var symbol_1 = require("./symbol");
var PathObject = /** @class */ (function () {
    function PathObject() {
    }
    return PathObject;
}());
exports.PathObject = PathObject;
function createProxy(path, obj) {
    if (path === void 0) { path = []; }
    if (obj === void 0) { obj = new PathObject(); }
    return new Proxy(obj, {
        get: function (target, prop) {
            if (prop === Symbol.toStringTag) {
                return true;
            }
            else if (prop === "__expand__") {
                return function (hint) { return path; };
            }
            else if (prop === Symbol.toPrimitive) {
                return function (hint) { return path.join("."); };
            }
            else if (prop === "constructor") {
                return PathObject;
            }
            else if (prop === "__symbol__") {
                return symbol_1.PathSymbol;
            }
            else {
                var result = (0, clone_deep_1.default)(path);
                result.push(prop);
                return createProxy(result, obj);
            }
        },
    });
}
exports.path = typeof Proxy === "undefined" ? null : createProxy();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF0aC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wYXRoL3BhdGgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsMERBQStCO0FBQy9CLG1DQUFzQztBQUN0QztJQUFBO0lBQXlCLENBQUM7SUFBRCxpQkFBQztBQUFELENBQUMsQUFBMUIsSUFBMEI7QUFBYixnQ0FBVTtBQUV2QixTQUFTLFdBQVcsQ0FBQyxJQUFnQixFQUFFLEdBQXNCO0lBQXhDLHFCQUFBLEVBQUEsU0FBZ0I7SUFBRSxvQkFBQSxFQUFBLFVBQVUsVUFBVSxFQUFFO0lBQzNELE9BQU8sSUFBSSxLQUFLLENBQUMsR0FBRyxFQUFFO1FBQ3BCLEdBQUcsRUFBSCxVQUFJLE1BQU0sRUFBRSxJQUFJO1lBQ2QsSUFBSSxJQUFJLEtBQUssTUFBTSxDQUFDLFdBQVcsRUFBRTtnQkFDL0IsT0FBTyxJQUFJLENBQUM7YUFDYjtpQkFBTSxJQUFJLElBQUksS0FBSyxZQUFZLEVBQUU7Z0JBQ2hDLE9BQU8sVUFBQyxJQUFTLElBQUssT0FBQSxJQUFJLEVBQUosQ0FBSSxDQUFDO2FBQzVCO2lCQUFNLElBQUksSUFBSSxLQUFLLE1BQU0sQ0FBQyxXQUFXLEVBQUU7Z0JBQ3RDLE9BQU8sVUFBQyxJQUFTLElBQUssT0FBQSxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFkLENBQWMsQ0FBQzthQUN0QztpQkFBTSxJQUFJLElBQUksS0FBSyxhQUFhLEVBQUU7Z0JBQ2pDLE9BQU8sVUFBVSxDQUFDO2FBQ25CO2lCQUFNLElBQUksSUFBSSxLQUFLLFlBQVksRUFBRTtnQkFDaEMsT0FBTyxtQkFBVSxDQUFDO2FBQ25CO2lCQUFNO2dCQUNMLElBQU0sTUFBTSxHQUFHLElBQUEsb0JBQUssRUFBQyxJQUFJLENBQUMsQ0FBQztnQkFDM0IsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFDbEIsT0FBTyxXQUFXLENBQUMsTUFBTSxFQUFFLEdBQUcsQ0FBQyxDQUFDO2FBQ2pDO1FBQ0gsQ0FBQztLQUNGLENBQUMsQ0FBQztBQUNMLENBQUM7QUFFWSxRQUFBLElBQUksR0FBUSxPQUFPLEtBQUssS0FBSyxXQUFXLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUMifQ==